import { VF_LOOKUP_TABLE } from 'AppSrc/core/components/forms/form-base-components/v-f-lookup-table';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  CONFIGURATION_ITEM,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import { searchConfigItems } from 'AppSrc/core/relationships/relationships-queries';
import {
  MOBILE,
  // RT_CONFIGURATION_ITEM,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = CONFIGURATION_ITEM;

const initialValues = '';

const resultsColumns = [
  { id: 'name', label: 'Configuration item' },
  { id: 'id', label: 'CI ID' },
  { id: 'serial', label: 'Serial Number' },
  { id: 'product', label: 'Product' },
  { id: 'organisation', label: 'Company' },
  { id: 'status', label: 'CI Status' },
];

const getRelationshipForConfigItem = (configItem) => {
  if (!configItem) { return null; }
  const {
    name,
    status,
    ciType, // fixed for dynamic reference type in CI
    reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
  } = configItem;
  return ({
    name,
    referenceId: name, // config item reference id should be name
    referenceType: ciType, // fixed for dynamic reference type in CI
    status,
    reconcilationId, // fixed for uat defect CI's & Node CI's in ACE
  });
};

const getSearchResultForConfigItem = (configItem) => {
  const {
    name,
    id,
    serial,
    product,
    organisation,
    status,
  } = configItem;
  return ({
    id: name,
    columnValues: {
      name,
      id,
      serial,
      product,
      organisation,
      status,
    },
    value: getRelationshipForConfigItem(configItem),
  });
};

const getSelectedIdForValue = (value) => value && value.referenceId;
const getInitialSearchQueryForValue = (value) => value && value.name;
const performSearch = (searchQuery) => searchConfigItems(MOBILE, searchQuery)
  // DISPATCH HERE FREYJA
  .then((configItems) => configItems.map(getSearchResultForConfigItem));

const vFParams = {
  fieldTitle: 'Configuration Item',
  placeholder: 'Search configuration items',
  performSearch,
  resultsColumns,
  getSelectedIdForValue,
  getInitialSearchQueryForValue,
};

const validator = (params) => {
  const {
    values,
  } = params;
  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_LOOKUP_TABLE);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push(noValue ? 'Please enter a configuration item' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const configurationItem = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_LOOKUP_TABLE,
};

export { configurationItem };
